export default __webpack_public_path__ + "static/media/EAST2460.34I-34262_-18481_0.5c8959e8.jpg";